import styled from "styled-components";

const ListAlpha = styled.ol`
  list-style-type: lower-alpha;
  padding-inline-start: 25px;
  > li {
    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
  > ul,
  ol {
    margin-top: 15px;
  }
`;

export default ListAlpha;
